<template>
	<div class="page">
		<video ref="vid" playsInline autoplay="autoplay" muted loop>
			<source v-if="$root.isMobile" src="/videos/mobile_stars.mp4" type="video/mp4">
			<source v-else src="/videos/desktop_stars.mp4" type="video/mp4">
			Your browser does not support the video tag.
		</video>
		<div class="page-inner ">
			<h1>What's your vibe?<br>Pick up to three</h1>
			<div class="genre-container">
				<div  class="button-container">
					<transition name="bounce">
						<button v-if="bounce" style="background:#00A4AC" :class="{ border: genres['pop'], 'button-bounce': buttonpressed === 1, 'button-pulse': buttonpulse}" @click="selectButton('pop', 1)">
							Pop
						</button>
						<!-- <div class="button-title">Pop</div> -->
					</transition>
				</div>
				<div class="button-container">
					<transition name="bounce">
						<button v-if="bounce" style="background:#EE632E" :class="{ border: genres['indie'], 'button-bounce': buttonpressed === 2, 'button-pulse': buttonpulse}" @click="selectButton('indie', 2)">
							Indie
						</button>
						<!-- <div class="button-title">Indie</div> -->
					</transition>
				</div>
				<div class="button-container">
					<transition name="bounce">
						<button v-if="bounce" style="background:#E60278" :class="{ border: genres['hip-hop'], 'button-bounce': buttonpressed === 3, 'button-pulse': buttonpulse}" @click="selectButton('hip-hop', 3)">
							Hip hop
						</button>
						<!-- <div class="button-title">Hip hop</div> -->
					</transition>
				</div>
				<div class="button-container">
					<transition name="bounce">
						<button v-if="bounce" style="background:#B99CFF" :class="{ border: genres['dance'], 'button-bounce': buttonpressed === 4, 'button-pulse': buttonpulse}" @click="selectButton('dance', 4)">
							Dance
						</button>
						<!-- <div class="button-title">Dance</div> -->
					</transition>
				</div>
				<div class="button-container">
					<transition name="bounce">
						<button v-if="bounce" style="background:#009FD6" :class="{ border: genres['rock'], 'button-bounce': buttonpressed === 5, 'button-pulse': buttonpulse}" @click="selectButton('rock', 5)">
							Rock
						</button>
						<!-- <div class="button-title">Rock</div> -->
					</transition>
				</div>
			</div>
			<div class="choices">Choices remaining: {{choices}}</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			fadeInContent: false,
			genres: {
				'pop': false,
				'indie': false,
				'hip-hop': false,
				'dance': false,
				'rock': false
			},
			choices: 3,
			bounce: false,
			buttonpressed: 0,
			buttonpulse: false
		};
	},
	mounted() {
		this.bounce = true
		setTimeout(() => {
			this.buttonpulse = true;
		}, 1400)
	},
	methods: {
		selectButton(genre, button) {
			this.buttonpulse = false;
			setTimeout(() => {
				this.buttonpulse = true;
			}, 1000)
			this.buttonpressed = button;
			setTimeout(() => {
				this.buttonpressed = 0;
			}, 500)
			let count = this.countSelectedButtons(this.genres, genre);
			this.genres[genre] = (count.length < 3 && !this.genres[genre]);

			count = this.countSelectedButtons(this.genres, genre);
			this.choices = 3 - count.length;
			localStorage.setItem("seedGenres", JSON.stringify(count));

			this.$emit('allowForwards', (count.length > 0));
		},
		countSelectedButtons(genres, genre) {
			let selected = [];
			for (let key in genres) {
				genres[key] ? selected.push(key) : '';
			} 
			return selected;
		}
	}
};
</script>

<style scoped>
.desktop .genre-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	width: 80%;
	max-width: 900px;
	transform: translateY(20%);
}

.desktop .button-container {
	width: 33.3%;
}

.desktop button {
	margin: 1rem;
    width: 15rem;
	height: 10rem;
	font-size: 1.8rem;
}

.desktop .choices {
	transform: translateY(6rem);
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

/* @keyframes bounce-in {
    0% {
        opacity: 0;
        transform: scale(.3);
        height: 0rem;
    }
    20% {
        height: 4rem;
    }
    50% {
        opacity: 1;
        transform: scale(1.05)
    }
    70% {
        transform: scale(.9)
    }
    100% {
        transform: scale(1)
    }
} */

.page-inner {
	justify-content: center;
	padding: 0 4rem;
	align-content: center;
}

.button-title {
    font-size: 1.5rem;
    width: 18rem;
    text-align: center;
    text-transform: uppercase;
	margin-top: 0.5rem;
}

button {
	display: flex;
    width: 15rem;
    justify-content: center;
	align-items: center;
    transition: all 0.3s ease-in-out;
    border-radius: 1rem;
	box-shadow: 0px 2px 3px 0px grey;
	margin: 0rem 1rem;
    height: 3.5rem;
	width: 16rem;
}

.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
	flex-direction: column;
	margin-bottom: 1rem;
	transition: all 0.3s;
}

.button-container:hover {
	transform: scale(1.03);
}

.border {
	border: 3px solid white;
}

.mobile h1 {
	width: 100%;
    z-index: 1;
    margin-top: 7rem;
    position: absolute;
    top: 0;
    font-size: 3.2rem;
}
</style>